import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationMessageRowComponent } from "~app/common/validation/validation-message-row/validation-message-row.component";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationMessageContainerComponent } from "../../../validation/validation-message-container/validation-message-container.component";
import { ValidationRuleDirective } from "../../../validation/validation-rule.directive";
import { HeaderComponent } from "../../header/header.component";
import { InputNumberComponent } from "../../input-number/input-number.component";
import { InputComponent } from "../../input/input.component";
import { TabComponent } from "../../tabs/tab/tab.component";
import { TabsComponent } from "../../tabs/tabs.component";
import { ShowroomValidationValidation } from "./showroom-validation.validation";

@Component({
    selector: "rask-showroom-validation",
    templateUrl: "./showroom-validation.component.html",
    styleUrls: ["./showroom-validation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        TabsComponent,
        TabComponent,
        InputNumberComponent,
        ValidationRuleDirective,
        FormsModule,
        InputComponent,
        ValidationMessageContainerComponent,
        ValidationMessageRowComponent
    ]
})
export class ShowroomValidationComponent implements OnInit {

    validationContext: ValidationContext;
    validation: IValidationScope;
    modelToTest: IModelToValidate;

    ngOnInit(): void {
        this.modelToTest = {
            stockar: 0,
            pappersark: 0,
            stubbar: 0,
            grenar: 0,
            alternativ1: "",
            alternativ2: "",
            alternativ3: "",
            alternativ4: ""
        };
        this.validationContext = ShowroomValidationValidation.init(this.modelToTest);
        this.validation = this.validationContext.current;
    }

}

export interface IModelToValidate {
    stockar: number;
    pappersark: number;
    stubbar: number;
    grenar: number;
    alternativ1: string;
    alternativ2: string;
    alternativ3: string;
    alternativ4: string;
}
